<template>
  <div
    class="request-support flex flex-col items-center w-full pb-20 px-5 sm:px-0"
    v-motion
    :initial="initialMotion"
    :enter="enterMotion"
  >
    <div class="mt-12 sm:mt-32">
      <Banner
        image="virtual-assistant.svg"
        :subtitle="'Teve algum problema na plataforma? Entre em contato com nosso Suporte, será um prazer ajudá-lo.'"
        :subtitleEN="'Did you have any problems on the platform? Contact our Support, it will be a pleasure to help you'"
        :title="'Suporte'"
        :titleEN="'Support'"
      />
    </div>

    <div
      class="request-support-box bg-white shadow-md p-6 rounded-md mt-16 w-full max-w-[800px]"
    >
      <Dropdown
        v-model="optionChoice"
        :options="supportOptions"
        optionLabel="name"
        optionValue="name"
        :placeholder="
          $t('labels.generic', {
            pt: 'Selecionar problema',
            en: 'Select problem',
          })
        "
        :class="`dropdown w-full ${v$.optionChoice.$error ? 'p-invalid' : ''}`"
      />
      <Errors :errors="v$.optionChoice.$errors" />

      <div class="mt-4">
        <Textarea
          v-model="msg"
          rows="5"
          cols="30"
          :class="v$.msg.$error ? 'p-invalid' : ''"
        />
        <Errors :errors="v$.msg.$errors" />
      </div>
    </div>
    <div class="w-full max-w-[800px] mt-8 mb-16 sm:mb-0 space-x-2">
      <Button
        :label="$t('labels.generic', { pt: 'Enviar', en: 'Send' })"
        :class="`w-full sm:w-1/4 h-12 sm:h-10 flex items-center justify-center text-sm ${msg && optionChoice ? 'btn-primary' : 'btn-disabled'}`"
        :disabled="!msg || !optionChoice"
        @click="sendEmail()"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { required } from "@/locale/locale.config";
import {
MotionEnter,
MotionInitial,
MotionTransition,
} from "@/models/motion.model";
import { SupportEmail } from "@/models/support-email.model";
import { SupportEmailRest } from "@/services/rest/email.rest";
import { Messages } from "@/utils/messages.util";
import { ToastFactory } from "@/utils/toast-factory.util";
import useVuelidate from "@vuelidate/core";
import { defineComponent } from "vue";

export default defineComponent({
  name: "request-support",
  emits: ["onSendEmail", "onCloseSupport"],
  data() {
    return {
      initialMotion: new MotionInitial(),
      enterMotion: new MotionEnter(1, 0, 0, new MotionTransition(40)),
      optionChoice: "" as string,
      previewImage: [] as any,
      formDataImage: [] as any,
      msg: "" as string,
      supportOptions: [
        {
          name: this.$t("labels.generic", {
            pt: "Estou enfrentando problemas técnicos na plataforma",
            en: "I'm facing technical issues on the platform",
          }),
          code: "1",
        },
        {
          name: this.$t("labels.generic", {
            pt: "Tive problemas durante o quiz",
            en: "I had problems during the quiz",
          }),
          code: "2",
        },
        {
          name: this.$t("labels.generic", {
            pt: "Outros problemas",
            en: "Other problems",
          }),
          code: "3",
        },
      ],
    };
  },
  computed: {
    rest(): SupportEmailRest {
      return new SupportEmailRest();
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      msg: { required },
      optionChoice: { required },
    };
  },
  methods: {
    dropHandler(event: any, refName: string) {
      const droppedFiles: any = event.dataTransfer.files;

      for (let i = 0; i < droppedFiles.length; i++) {
        this.pickFile(droppedFiles[i], true);
      }
      (this.$refs[refName] as HTMLElement).style.backgroundColor = "white";
    },
    dragOverHandler(refName: string) {
      (this.$refs[refName] as HTMLElement).style.backgroundColor =
        "rgba(128, 128, 128, 0.1)";
    },
    dragLeaveHandler(refName: string) {
      (this.$refs[refName] as HTMLElement).style.backgroundColor = "white";
    },
    chooseFiles() {
      let fileInputElement: any = this.$refs.fileInput;
      fileInputElement.click();
    },
    pickFile(file: any = "", drag = false) {
      if (!drag) {
        let input: any = this.$refs.fileInput;
        file = input.files[0];
      }

      const formData = new FormData();
      formData.append("file", file);
      this.formDataImage.push(formData);
      this.previewImage.push(file);
    },
    removeImageArray(index: number) {
      this.previewImage.splice(index, 1);
      this.formDataImage.splice(index, 1);
    },
    closeSupport() {
      // this.$emit("onCloseSupport", false);
    },
    sendEmail() {
      this.v$.msg.$touch();
      this.v$.optionChoice.$touch();
      if (!this.v$.msg.$error && !this.v$.optionChoice.$error) {
        let data: SupportEmail = {
          description: this.msg,
          problem: this.optionChoice,
        };
        this.rest.sendEmail(data).subscribe({
          next: () => {
            this.optionChoice = "";
            this.msg = "";
            this.v$.msg.$reset();
            this.v$.optionChoice.$reset();
            this.$toast.add(ToastFactory.success(Messages.EMAIL_SUCCESS));
          },
        });
      }
    },
  },
});
</script>

<style></style>
